import React, {ReactNode} from 'react';
import cn from 'classnames';

import FormGroup from 'shared/ui/FormGroup/FormGroup';
import {RemoveFieldButton} from 'entities/monitor';

import styles from '../CheckboxBlock.module.scss';

interface IFieldCardProps {
    selective: boolean,
    freeTariff: boolean,
    auth?: boolean,
    onRemove?: () => void,
    children: ReactNode,
}

const FieldCard: React.FC<IFieldCardProps> = ({selective, freeTariff, auth, onRemove, children}) => {
    const className = selective
        ? cn(styles.selectiveCard, auth && styles.auth)
        : cn(styles.formGroup, auth && styles.auth, freeTariff && styles.freeformGroup);

    return (
        <FormGroup className={className}>
            {selective && onRemove && <RemoveFieldButton onRemove={onRemove} floating/>}
            {children}
        </FormGroup>
    );
};

export default FieldCard;
